<div
  class="d-flex flex-column justify-content-center align-items-center view-credential"
>
  <div
    class="credential-header d-flex flex-column justify-content-center align-items-center w-100"
  >
    <span class="credential-circle-icon">
      <img
        alt="User Icon"
        src="assets/images/credential-card-white-circle.png"
      />
    </span>
    <span class="title">
      {{
        selectedCredentials?.cardName
          ? selectedCredentials?.cardName
          : ("NOT_AVAILABLE" | translate)
      }}
    </span>
    <div
      class="d-flex flex-row justify-content-center align-items-center w-100 serial"
    >
      <div class="text-right mr-2">
        {{ ("SERIAL_NUM" | translate) + ":" }}
      </div>
      <div class="py-2">
        <app-profile-tooltip [showHelpCursor]="true">
          {{
            selectedCredentials?.badgeId
              ? selectedCredentials?.badgeId
              : ("NOT_AVAILABLE" | translate)
          }}
        </app-profile-tooltip>
      </div>
    </div>

    <div
      class="d-flex flex-row justify-content-center align-items-center w-75 serial pb-2"
    >
      <div class="text-right mr-2">
        {{ "STATUS" | translate }}
      </div>
      <div class="serial py-1">
        <app-profile-tooltip [showHelpCursor]="true">
          {{
            selectedCredentials?.cardStatus === ("PENDING_BLOCKED" | translate)
              ? ("BLOCKLISTED" | translate)
              : selectedCredentials?.cardStatus === ("BLOCKED" | translate)
              ? ("READY_TO_BLOCK" | translate)
              : selectedCredentials?.cardStatus
              ? (selectedCredentials?.cardStatus | titlecase)
              : ("NOT_AVAILABLE" | translate)
          }}
        </app-profile-tooltip>
      </div>
    </div>
  </div>
  <div
    class="credential-detail d-flex flex-column justify-content-center align-items-center w-100 mt-2"
  >
    <span
      class="detail-item d-flex flex-row justify-content-between w-100 align-items-center top-element px-3"
    >
      <span class="col-5">{{ "NAME" | translate }}</span>
      <span class="pr-2 col-7 text-right">
        <strong>
          <app-profile-tooltip [showHelpCursor]="true">
            {{
              selectedCredentials?.cardName
                ? selectedCredentials?.cardName
                : ("NOT_AVAILABLE" | translate)
            }}
          </app-profile-tooltip>
        </strong>
      </span>
    </span>

    <span
      class="detail-item d-flex flex-row justify-content-between w-100 align-items-center middle-element px-3"
    >
      <span class="col-5">{{ "SERIAL_NUM" | translate }}</span>
      <span class="pr-2 col-7 text-right">
        <strong>
          <app-profile-tooltip [showHelpCursor]="true">
            {{
              selectedCredentials?.badgeId
                ? selectedCredentials?.badgeId
                : ("NOT_AVAILABLE" | translate)
            }}
          </app-profile-tooltip>
        </strong>
      </span>
    </span>

    <span
      class="detail-item d-flex flex-row justify-content-between w-100 align-items-center last-element px-3"
    >
      <span class="col-5">{{ "ACCESS" | translate }}</span>
      <span
        class="col-7 text-right d-flex flex-row justify-content-end align-items-center"
      >
        <span>
          <strong>
            {{
              selectedCredentials?.accessCount
                ? selectedCredentials?.accessCount
                : "0"
            }}
          </strong>
        </span>
        <button
          type="button"
          mat-icon-button
          aria-label="access-btn"
          class="access-btn"
          (click)="viewCardAccess()"
          [disabled]="!selectedCredentials?.accessCount"
        >
          <mat-icon class="arrow-btn">arrow_forward_ios</mat-icon>
        </button>
      </span>
    </span>
    <!-- MPC-7907 Commented for future use not needed for now -->
    <!--  <span
      class="detail-item d-flex flex-row justify-content-between w-100 align-items-center last-element px-3"
    >
      <span class="col-9">{{ 'DISABLE_ACCESS' | translate }}</span>
      <span class="pr-2 col-3 text-right">
        <mat-slide-toggle class="mat-toggle" color="primary"></mat-slide-toggle>
      </span>
    </span> -->
  </div>

  <!--  <div
    class="d-flex flex-row justify-content-center align-items-center mt-20 d-none"
    type="button"
  >
    <img src="assets/svg/ico-close-circle-outline.svg" />
    <p class="remove-btn ml-2 pt-2">
      {{ 'DELETE_CREDENTIAL' | translate }}
    </p>
  </div> -->
</div>
